import * as Sentry from '@sentry/react'
import { createRouter } from '@tanstack/react-router'
import { Config } from './config/Config'
import { routeTree } from './routeTree.gen'
import { queryClient } from './services/queryClient'

let latestEventId: string | undefined
const eventIdListeners = new Set<() => void>()

const setLatestEventId = (eventId: string | undefined): void => {
  latestEventId = eventId
  eventIdListeners.forEach(listener => listener())
}

export const getLatestSentryEventId = (): string | undefined => {
  return latestEventId
}

export const subscribeToSentryEventId = (
  listener: () => void
): (() => void) => {
  eventIdListeners.add(listener)

  return () => {
    eventIdListeners.delete(listener)
  }
}

export const router = createRouter({
  routeTree,
  context: {
    auth: undefined!,
    queryClient,
  },
})

Sentry.init({
  dsn: 'https://7bddb729af84ffed5ae12ccbd426f524@o4510793695297536.ingest.de.sentry.io/4512010921902160',
  enabled: !import.meta.env.DEV,
  environment: Config.sentryEnvironment,
  integrations: [
    Sentry.tanstackRouterBrowserTracingIntegration(router),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^\//, Config.api],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend(event) {
    setLatestEventId(event.event_id)
    return event
  },
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
